document.addEventListener("DOMContentLoaded", function () {
  const readMoreContainers = document.querySelectorAll(".read-more-container");

  const TEXT_LINE_HEIGHT = 27;
  const FOUR_LINES_OF_TEXT = TEXT_LINE_HEIGHT * 4;

  if (readMoreContainers && readMoreContainers.length) {
    readMoreContainers.forEach(function (readMoreContainer) {
      if (readMoreContainer.scrollHeight < FOUR_LINES_OF_TEXT) {
        const readMoreButton =
          readMoreContainer.parentNode.querySelector(".read-more-button");
        readMoreButton.style.display = "none";
        readMoreContainer.classList.add("expanded");
        readMoreContainer.style.maxHeight =
          readMoreContainer.scrollHeight + "px";
      }
    });
  }

  const readMoreButtons = document.querySelectorAll(".read-more-button");

  if (readMoreButtons && readMoreButtons.length) {
    readMoreButtons.forEach(function (readMoreButton) {
      readMoreButton.addEventListener("click", function () {
        const parentNode = this.parentNode;
        const readMoreContainer = parentNode.querySelector(
          ".read-more-container"
        );

        if (readMoreContainer) {
          if (readMoreContainer.classList.contains("expanded")) {
            readMoreContainer.classList.remove("expanded");
            readMoreButton.classList.remove("expanded");
            readMoreContainer.style.maxHeight = "";
          } else {
            readMoreContainer.classList.add("expanded");
            readMoreButton.classList.add("expanded");
            readMoreContainer.style.maxHeight =
              readMoreContainer.scrollHeight + "px";
          }
        }
      });
    });
  }
});
